import { render, staticRenderFns } from "./CourseEditV2.vue?vue&type=template&id=32fcc527&"
import script from "./CourseEditV2.vue?vue&type=script&lang=ts&"
export * from "./CourseEditV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports